import React, { useState } from "react";
import AddImage from "../../Global Functions/addImage";
import { AddImageAll } from "../../Global Functions/addImage";
import toast from "react-hot-toast";
const iconProps = { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };

const CopyIcon = () => (
    <svg {...iconProps}><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
);

const DownloadIcon = () => (
    <svg {...iconProps}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
);

const SpinnerIcon = () => (
    <svg {...iconProps}><path d="M21 12a9 9 0 1 1-6.2-8.55"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" /></path></svg>
);

const getFileName = (u) => { try { return decodeURIComponent(u.split("?")[0].split("/").pop()).replace(/^\d{10,}_/, ""); } catch { return u; } };
const getExt = (u) => { const n = getFileName(u); const i = n.lastIndexOf("."); return i > -1 ? n.slice(i + 1, i + 5).toUpperCase() : "FILE"; };

const UploadCard = ({ title, hint, accept, color, url, uploading, downloading, onFile, onCopy, onDownload }) => (
    <div style={{ padding: "16px", backgroundColor: "#f8f9fa", borderRadius: "12px", border: "1px solid #e8e8e8", display: "flex", flexDirection: "column", gap: "10px" }}>
        <div>
            <div style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>{title}</div>
            <div style={{ fontSize: "12px", color: "#888" }}>{hint}</div>
        </div>

        <label style={{
            display: "block", padding: "10px", textAlign: "center", fontSize: "13px", fontWeight: 500,
            border: `1px dashed ${color}`, borderRadius: "8px", color, backgroundColor: "#fff",
            cursor: uploading ? "not-allowed" : "pointer", opacity: uploading ? 0.6 : 1
        }}>
            {uploading ? "Uploading..." : "Choose file"}
            <input type="file" accept={accept} onChange={onFile} disabled={uploading} style={{ display: "none" }} />
        </label>

        {url && (
            <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", backgroundColor: "#fff", border: "1px solid #e8e8e8", borderRadius: "10px" }}>
                <div style={{ width: "36px", height: "36px", flexShrink: 0, borderRadius: "8px", backgroundColor: `${color}14`, color, fontSize: "10px", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {getExt(url)}
                </div>
                <div title={url} style={{ flex: 1, minWidth: 0, fontSize: "12px", fontWeight: 500, color: "#1a1a1a", lineHeight: 1.35, wordBreak: "break-all", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                    {getFileName(url)}
                </div>
                <button onClick={onCopy} aria-label="Copy URL" title="Copy URL"
                    style={{ width: "32px", height: "32px", flexShrink: 0, backgroundColor: `${color}14`, color, border: `1px solid ${color}40`, borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CopyIcon />
                </button>
                <button onClick={onDownload} disabled={downloading} aria-label="Download" title="Download"
                    style={{ width: "32px", height: "32px", flexShrink: 0, backgroundColor: `${color}14`, color, border: `1px solid ${color}40`, borderRadius: "8px", cursor: downloading ? "not-allowed" : "pointer", opacity: downloading ? 0.7 : 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {downloading ? <SpinnerIcon /> : <DownloadIcon />}
                </button>
            </div>
        )}
    </div>
);

const MediaUploadPopup = ({ visible, onClose }) => {
    const [uploadedPhotoUrl, setUploadedPhotoUrl] = useState("");
    const [uploadedPhotoUrlAll, setUploadedPhotoUrlAll] = useState("");
    const [uploadedVideoUrl, setUploadedVideoUrl] = useState("");
    const [uploadedPdfUrl, setUploadedPdfUrl] = useState("");
    const [photoUploading, setPhotoUploading] = useState(false);
    const [photoUploadingAll, setPhotoUploadingAll] = useState(false);
    const [videoUploading, setVideoUploading] = useState(false);
    const [pdfUploading, setPdfUploading] = useState(false);
    const [photoDownloading, setPhotoDownloading] = useState(false);
    const [photoDownloadingAll, setPhotoDownloadingAll] = useState(false);
    const [videoDownloading, setVideoDownloading] = useState(false);
    const [pdfDownloading, setPdfDownloading] = useState(false);

    const handleMediaUpload = async (event, setUrl, setUploading) => {
        const uploadedFile = event.target.files[0];
        if (!uploadedFile) {
            toast.error("No file selected");
            return;
        }

        setUploading(true);
        const responseUrl = await AddImage(uploadedFile);
        setUploading(false);

        if (responseUrl) {
            setUrl(responseUrl);
        } else {
            toast.error("File upload failed");
        }
    };

    const handleMediaUploadAll = async (event, setUrl, setUploading) => {
        const uploadedFile = event.target.files[0];
        if (!uploadedFile) {
            toast.error("No file selected");
            return;
        }

        setPhotoUploadingAll(true);
        const responseUrl = await AddImageAll(uploadedFile);
        setPhotoUploadingAll(false);

        if (responseUrl) {
            setUrl(responseUrl);
        } else {
            toast.error("File upload failed");
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => toast.success("Copied to clipboard"))
            .catch(() => toast.error("Copy failed"));
    };

    const downloadFile = async (url, type, setDownloading) => {
        setDownloading(true);
        try {
            const encodedUrl = url.split('/').map((part, i) =>
                i === 0 ? part : encodeURIComponent(decodeURIComponent(part))
            ).join('/');
            const response = await fetch(encodedUrl);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;

            const urlParts = url.split('/').filter(Boolean);
            const rawFilename = decodeURIComponent(urlParts[urlParts.length - 1] || "").trim();
            const filename = rawFilename.replace(/\s+/g, "_")
                || `uploaded-${type}-${Date.now()}.${type === 'photo' ? 'jpg' : type === 'pdf' ? 'pdf' : 'mp4'}`;
            link.download = filename;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} downloaded`);
        } catch (error) {
            toast.error("Download failed");
            console.error("Download error:", error);
        } finally {
            setDownloading(false);
        }
    };

    if (!visible) return null;

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backdropFilter: "blur(4px)"
        }}>
            <div style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "32px",
                maxWidth: "640px",
                width: "90%",
                maxHeight: "90vh",
                overflow: "auto",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)"
            }}>
                <h3 style={{
                    margin: "0 0 24px 0",
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "#1a1a1a"
                }}>Upload Media</h3>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "16px", marginBottom: "24px" }}>
                    <UploadCard
                        title="Upload Any Image" hint="Original, no conversion" accept="image/*" color="#4caf50"
                        url={uploadedPhotoUrlAll} uploading={photoUploadingAll} downloading={photoDownloadingAll}
                        onFile={(e) => handleMediaUploadAll(e, setUploadedPhotoUrlAll, setPhotoUploadingAll)}
                        onCopy={() => copyToClipboard(uploadedPhotoUrlAll)}
                        onDownload={() => downloadFile(uploadedPhotoUrlAll, 'photo', setPhotoDownloadingAll)}
                    />
                    <UploadCard
                        title="Image → WEBP" hint="Compressed at 60% quality" accept="image/*" color="#009688"
                        url={uploadedPhotoUrl} uploading={photoUploading} downloading={photoDownloading}
                        onFile={(e) => handleMediaUpload(e, setUploadedPhotoUrl, setPhotoUploading)}
                        onCopy={() => copyToClipboard(uploadedPhotoUrl)}
                        onDownload={() => downloadFile(uploadedPhotoUrl, 'photo', setPhotoDownloading)}
                    />
                    <UploadCard
                        title="Video" hint="MP4, MOV, WEBM" accept="video/*" color="#2196f3"
                        url={uploadedVideoUrl} uploading={videoUploading} downloading={videoDownloading}
                        onFile={(e) => handleMediaUpload(e, setUploadedVideoUrl, setVideoUploading)}
                        onCopy={() => copyToClipboard(uploadedVideoUrl)}
                        onDownload={() => downloadFile(uploadedVideoUrl, 'video', setVideoDownloading)}
                    />
                    <UploadCard
                        title="PDF / CSV / Excel" hint="PDF, CSV, XLS, XLSX · uploaded as-is"
                        accept=".pdf,.csv,.xls,.xlsx,application/pdf,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        color="#e53935"
                        url={uploadedPdfUrl} uploading={pdfUploading} downloading={pdfDownloading}
                        onFile={(e) => handleMediaUpload(e, setUploadedPdfUrl, setPdfUploading)}
                        onCopy={() => copyToClipboard(uploadedPdfUrl)}
                        onDownload={() => downloadFile(uploadedPdfUrl, 'pdf', setPdfDownloading)}
                    />
                </div>

                {/* Close Button */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: "12px 32px",
                            backgroundColor: "black",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "600",
                            transition: "all 0.2s"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#e0e0e0";
                            e.target.style.color = "black";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "black";
                            e.target.style.color = "white";
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MediaUploadPopup;